import {
  buildGtmHeadScripts,
  buildGtmNoscriptIframeSrc,
  type GtmHeadScripts,
} from 'app-core'
import { GTM_ID, GTM_QUERY_TAIL } from './consts'

export const buildDevicesGtmHeadScripts = (): GtmHeadScripts =>
  buildGtmHeadScripts()

export const DEVICES_GTM_NOSCRIPT_IFRAME_SRC = buildGtmNoscriptIframeSrc({
  gtmId: GTM_ID,
  gtmQueryTail: GTM_QUERY_TAIL,
})
